import React from 'react';
import type { FormikProps } from 'formik';
import { CustomTextField } from 'components/FormFields/CustomTextField/CustomTextField';
import { CustomSelect } from 'components/FormFields/CustomSelect/CustomSelect';

/** The fields both user forms carry. Create requires a password, edit does not. */
export interface UserFormValues {
  username: string;
  email: string;
  password: string;
  passwordRepeat: string;
  permissionId: string;
}

interface IProps {
  form: FormikProps<UserFormValues>;
  options: { id: string; title: string }[];
  passwordHint?: string;
}

export const UserFormFields: React.FC<IProps> = ({ form, options, passwordHint = '' }) => {
  const { values, errors, touched, handleChange, handleBlur, setFieldValue } = form;

  return (
    <>
      <CustomTextField autoComplete="off" name="username" label="Benutzername" value={values.username} onChange={handleChange} onBlur={handleBlur} error={touched.username && Boolean(errors.username)} helperText={touched.username ? errors.username : ''} />

      <CustomTextField autoComplete="off" name="email" label="E-Mail" value={values.email} onChange={handleChange} onBlur={handleBlur} error={touched.email && Boolean(errors.email)} helperText={touched.email ? errors.email : ''} />

      <CustomTextField autoComplete="new-password" name="password" label="Passwort" type="password" value={values.password} onChange={handleChange} onBlur={handleBlur} error={touched.password && Boolean(errors.password)} helperText={touched.password ? errors.password : passwordHint} />

      <CustomTextField autoComplete="new-password" name="passwordRepeat" label="Passwort (Wiederholen)" type="password" value={values.passwordRepeat} onChange={handleChange} onBlur={handleBlur} error={touched.passwordRepeat && Boolean(errors.passwordRepeat)} helperText={touched.passwordRepeat ? errors.passwordRepeat : ''} />

      <CustomSelect name="permissionId" label="Rolle" options={options} value={values.permissionId} onChange={(value) => void setFieldValue('permissionId', value)} error={touched.permissionId && Boolean(errors.permissionId)} helperText={touched.permissionId ? errors.permissionId : ''} />
    </>
  );
};
